import {
  IRegisterUserForm,
  IUserPermissionQuery,
} from "services/userManagement/types";

export const userFormToQuery = (
  userForm: IRegisterUserForm,
  userId: string
): IUserPermissionQuery => {
  const permissions = Object.entries(userForm.permissions).flatMap(
    ([domainName, domainData]) =>
      domainData.permissions.map((permission) => ({
        item1: {
          userId,
          permissionDomainName: domainName,
          permissionFlagValue: permission.flag,
        },
        item2: permission.isSelected,
      }))
  );

  return {
    permissions,
  };
};
